// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"6dbd3212","42":"f2d791c5","260":"567ac63c","319":"2c920015","336":"9c46aacc","488":"0407b381","596":"e8cb61c8","725":"4a0422f8","885":"7b15fd98"}[chunkId] + ".chunk.js";
};